import { render, staticRenderFns } from "./GroupEditorPopup.vue?vue&type=template&id=c3436ccc&scoped=true&"
import script from "./GroupEditorPopup.vue?vue&type=script&lang=ts&"
export * from "./GroupEditorPopup.vue?vue&type=script&lang=ts&"
import style0 from "./GroupEditorPopup.vue?vue&type=style&index=0&id=c3436ccc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3436ccc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VImg,VList,VListItem,VListItemContent,VTextField,VTooltip})
